const getDataDb = async (formData,controller,opt) => {
  return fetch(`REST/controllers/${controller}?opt=${opt}`,{
    method: 'POST',
    mode: 'cors',
    body: formData
  })
  .then( response => response.json() )
}

const setDataDb = async (formData,controller,opt,method="POST") => {
  return fetch(`REST/controllers/${controller}?opt=${opt}`,{
    method,
    mode: 'cors',
    body: formData
  })
  .then( response => response.json() )
}

const deleteDataDb = async(formData,controller,opt) => {
  return fetch(`REST/controllers/${controller}?opt=${opt}`,{
    method: 'POST',
    mode: 'cors',
    body: formData
  })
  .then( response => response.json() )
}

export {
  getDataDb,
  setDataDb,
  deleteDataDb,
}